import ParameterErrors from '../errors/ParameterErrors';
import ParameterValidation from '../validation/ParameterValidation';
import EulerAngles from '../geometry/EulerAngles';
const{throwNotProvided, throwNotOfType}=ParameterErrors;
export default class Scene360Hotspot{
	constructor(props){
		const {type, iconRelativePath, eulerAngles, pointingAtEulerAngles} = props;
		if(type ===undefined||type===null)
			throwNotProvided('type');
		this._type = type;
		if(iconRelativePath ===undefined||iconRelativePath===null)
			throwNotProvided('iconRelativePath');
		this._iconRelativePath = iconRelativePath;
		if(eulerAngles ===undefined||eulerAngles===null)
			throwNotProvided('eulerAngles');
		if(!eulerAngles instanceof EulerAngles)
			throwNotOfType('eulerAngles', 'EulerAngles');
		if(pointingAtEulerAngles&&(!pointingAtEulerAngles instanceof EulerAngles))
			throwNotOfType('pointingAtEulerAngles', 'EulerAngles');
		this._eulerAngles = eulerAngles;
		this._pointingAtEulerAngles = pointingAtEulerAngles;
		this._rotateToCompensate = false;
	}
	get iconRelativePath(){
		return this._iconRelativePath;
	}
	get type(){
		return this._type;
	}
	get eulerAngles(){
		return this._eulerAngles;
	}
	get pointingAtEulerAngles(){
		return this._pointingAtEulerAngles;
	}
	get rotateToCompensate(){
		return this._rotateToCompensate;
	}
}
